import LoadingCircle from "@pathwright/ui/src/components/loading/LoadingCircle"
import AssessmentView from "content/assessment/views/assessment"
import { wrapMarionetteView } from "lib/core/react/react-utils"
import PropTypes from "prop-types"
const AssessmentViewWrapped = wrapMarionetteView(AssessmentView)

import { StepPermissionLock } from "library/show/components/step/lock"

const AssessmentWrapper = function (props, { user }) {
  // hack to prevent previewing assessment
  if (!user) {
    return <StepPermissionLock />
  }

  const { assessment, step, isReview, handleLegacyContentCompletion } = props

  const isAssessmentEditor = assessment.method === "assessment_editor"
  // Assessment editor based content has multi-load cylce
  const isLoading = isAssessmentEditor && assessment.assessment == null
  return (
    <div
      className="AssessmentWrapper"
      style={{ minHeight: `${isLoading ? 300 : 0}px` }}
    >
      {isLoading ? (
        <LoadingCircle />
      ) : (
        <AssessmentViewWrapped
          data={assessment}
          step={step}
          isReview={isReview || false}
          handleLegacyContentCompletion={handleLegacyContentCompletion}
        />
      )}
    </div>
  )
}

AssessmentWrapper.displayName = "AssessmentWrapper"
AssessmentWrapper.contextTypes = { user: PropTypes.object }

export default AssessmentWrapper
